import { Controller } from "@hotwired/stimulus"

export default class InlineEditController extends Controller {
  static targets = ["viewMode", "editMode", "editButton", "form", "stockFields"]

  declare viewModeTarget: HTMLElement
  declare editModeTarget: HTMLElement
  declare editButtonTarget: HTMLElement
  declare hasStockFieldsTarget: boolean
  declare stockFieldsTarget: HTMLElement

  toggleEdit(event: Event) {
    event.preventDefault()

    this.viewModeTarget.classList.add("d-none")
    this.editModeTarget.classList.remove("d-none")
    this.editButtonTarget.classList.add("d-none")
  }

  cancelEdit(event: Event) {
    event.preventDefault()
    this.editModeTarget.classList.add("d-none")
    this.viewModeTarget.classList.remove("d-none")
    this.editButtonTarget.classList.remove("d-none")

    const form = this.editModeTarget.querySelector("form")
    if (form) {
      form.reset()
    }
  }

  showViewMode() {
    this.editModeTarget.classList.add("d-none")
    this.viewModeTarget.classList.remove("d-none")
    this.editButtonTarget.classList.remove("d-none")
  }

  toggleStockFields(event: Event) {
    if (!this.hasStockFieldsTarget) return

    const select = event.target as HTMLSelectElement
    if (select.value === "public") {
      this.stockFieldsTarget.style.display = ""
    } else {
      this.stockFieldsTarget.style.display = "none"
    }
  }
}
